import React, { Component, Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core/';
import MarkerClusterGroup from 'react-leaflet-markercluster';
import { createClusterCustomIcon } from '../formatters';
import 'react-leaflet-markercluster/dist/styles.min.css';
import {
    PaginatedStaticDataTable,
    Marker,
    Map,
    Route,
    VSpacer
} from 'sm-react-components';

import * as formatters from '../formatters';

const styles = {
    card: {
        marginBottom: '10px'
    }
};

class PlaceProfilerV1Results extends Component {
  state = {
      places: undefined,
      selected: undefined,
      routes: undefined
  };

  componentDidMount = () => {
      this.calculatePlaces();
  };

  handleSelectPlace = place => {
      this.setState({
          selected: place
      });
  };

  calculatePlaces = () => {
      // MAP ALL POINTS
      const { solution, problem } = this.props;
      const places = [];
      solution.places &&
      Object.values(solution.places).forEach(place => {
          let durationDefault = 0;
          place.durations.forEach(duration => {
              if (duration.service_id === 'default') {
                  durationDefault = duration.mean;
              }
          });
          places.push({
              location: place.location,
              parkings: place.coordinates,
              type: 'place',
              id: place.id,
              duration: durationDefault,
              timewindows: place.timewindows,
              visitcount: place.visit_count,
              place
          });
      });

      const routes =
      problem.routes &&
      problem.routes.map((route, idx) => ({
          id: route.driver_id || idx, // ESTA AIXI PERO SI NO CANVIA SHA DE CANVIAR
          type: route.device_type,
          duration:
          route.traces[route.traces.length - 1].timestamp -
          route.traces[0].timestamp,
          steps: route.traces.map(trace => ({
              lat: trace.lat,
              lng: trace.lng
          }))
      }));

      this.setState({
          places,
          routes
      });
  };

  render() {
      const { places, selected, routes } = this.state;
      return (
          <div style={{ maxWidth: '80vw' }}>
              <VSpacer />
              <Typography variant="h5">Places</Typography>

              {places && places.length === 0 && (
                  <Fragment>
                      <VSpacer />
                      <div>No Places</div>
                  </Fragment>
              )}
              <PaginatedStaticDataTable
                  docs={places}
                  mapping={[
                      {
                          column: 'id',
                          name: 'Id',
                          sortable: true,
                          formatter: doc =>
                              selected && doc === selected.id ? (
                                  <div style={{ color: '#FF8200' }}>{doc}</div>
                              ) : (
                                  doc
                              )
                      },
                      {
                          column: 'location',
                          name: 'Location',
                          formatter: formatters.coordinate
                      },
                      {
                          column: 'visitcount',
                          name: 'Visits',
                          sortable: true
                      },
                      {
                          column: 'duration',
                          name: 'Duration',
                          formatter: formatters.duration,
                          sortable: true
                      },
                      {
                          column: 'timewindows',
                          name: 'Time windows',
                          formatter: formatters.arrayTimewindowsToString
                      }
                  ]}
                  search="live"
              />

              {places && places.length > 0 && (
                  <Map height={540}>
                      {routes &&
              routes.map((route, index) => [
                  <Marker
                      key={`markerStart_${index}`}
                      lat={route.steps[0].lat}
                      lng={route.steps[0].lng}
                      kind={'start'}
                      color={index}
                  />,
                  <Marker
                      key={`markerEnd_${index}`}
                      lat={route.steps[route.steps.length - 1].lat}
                      lng={route.steps[route.steps.length - 1].lng}
                      kind={'end'}
                      color={index}
                  />
              ])}

                      {routes &&
              routes.map((route, index) => {
                  const routeSelected = selected && selected.id === route.id;
                  const routeKey =
                  'route-' + route.id + (routeSelected ? '-selected' : '');
                  return (
                      <Route key={routeKey} path={route.steps} color={index} />
                  );
              })}
                      <MarkerClusterGroup
                          disableClusteringAtZoom={17}
                          iconCreateFunction={createClusterCustomIcon}
                      >
                          {places &&
                places.map((item, index) => {
                    const poiKey = 'places-poi-' + index;
                    return (
                        <Marker
                            key={poiKey}
                            onClick={() => this.handleSelectPlace(item)}
                            lat={item.location.lat}
                            lng={item.location.lng}
                            selected={selected && item.id === selected.id}
                            kind={item.type}
                            label={item.id}
                        />
                    );
                })}
                      </MarkerClusterGroup>
                  </Map>
              )}
          </div>
      );
  }
}

export default withStyles(styles)(PlaceProfilerV1Results);
